import { RouteProp, useRoute } from "@react-navigation/native";

import { RootStackParamList } from "../lib/appNavigation";

const useAppRoute = () => {
  return useRoute<RouteProp<RootStackParamList>>();
};

export default useAppRoute;
